import axiosInstance from "../Instance/axiosInstance";
import { ArticleTypes } from "./Article.types";




// ✅ Get Categories (Admin only)
export const getCategories = async (): Promise<any[]> => {
  const response = await axiosInstance.get<{ success: boolean; data: any[] }>(
    "/categories" // This will hit /api/v1/categories if your baseURL is set correctly
  );
  
  return response.data.data; // Return the categories array directly
};

// ✅ Get All Articles
export const getAllArticles = async (): Promise<ArticleTypes[]> => {
  const response = await axiosInstance.get<{ data: any[] }>(
    "/admin/articles"
  );

  const mapped: ArticleTypes[] = response.data.data.map((item) => ({
    id: item.id,
    articleName: item.articleName,
    description: item.description,

    metalTypeId: item.metalTypeId,
    categoryId: item.categoryId,

    metalType: item.metalType
      ? {
          id: item.metalType.id,
          name: item.metalType.name,
        }
      : undefined,

    category: item.category
      ? {
          id: item.category.id,
          name: item.category.name,
        }
      : undefined,

    status: item.status === "Inactive" ? "Inactive" : "Active",

    isActive: item.isActive,
    isDelete: item.isDelete,
    createdAt: item.createdAt ? new Date(item.createdAt) : undefined,
    updatedAt: item.updatedAt ? new Date(item.updatedAt) : undefined,
  }));

  return mapped;
};


// ✅ Get Article By ID
export const getArticleById = async (
  id: number | string
): Promise<ArticleTypes> => {
  const response = await axiosInstance.get<{ data: any }>(
    `/admin/article/${id}`
  );

  const item = response.data.data;

  return {
    id: item.id,
    articleName: item.articleName,
    description: item.description,
    metalTypeId: item.metalTypeId,
    categoryId: item.categoryId,

    metalType: item.metalType,
    category: item.category,

    status: item.status,
    isActive: item.isActive,
    isDelete: item.isDelete,
    createdAt: item.createdAt ? new Date(item.createdAt) : undefined,
    updatedAt: item.updatedAt ? new Date(item.updatedAt) : undefined,
  };
};


// ✅ Create Article
export const createArticle = async (
  payload: {
    metalTypeId: number;
    categoryId: number;
    articleName: string;
    description?: string;
  }
): Promise<ArticleTypes> => {
  const { data } = await axiosInstance.post<{ data: ArticleTypes }>(
    "/admin/article/create",
    payload
  );

  return data.data;
};


// ✅ Update Article
export const updateArticleApi = async (
  id: number | string,
  payload: Partial<ArticleTypes>
): Promise<ArticleTypes> => {
  const { data } = await axiosInstance.put<{ data: ArticleTypes }>(
    `/admin/article/${id}`,
    payload
  );

  return data.data;
};


// ✅ Change Status
export const updateArticleStatusApi = async (id: number): Promise<void> => {
  await axiosInstance.put(`/admin/article/status/${id}`);
};


// ✅ Delete Article (Soft Delete)
export const deleteArticleApi = async (id: number): Promise<void> => {
  await axiosInstance.delete(
    `/admin/article/${id}`
  );
};


// Add these functions to your existing Article.service.ts file

// ✅ Download Excel Template
export const downloadExcelTemplate = async (): Promise<void> => {
  try {
    const response = await axiosInstance.get("/download_Excel_Article/template.xlsx", {
      responseType: "blob",
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "article_template.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
    throw error;
  }
};

// ✅ Bulk Upload Excel
export const bulkUploadArticles = async (file: File): Promise<any> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post("/admin/article/bulk-upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};